import { CommandBarButton } from "@fluentui/react";
import React, { useContext } from "react";

import { OnPremOrderListingContext } from "../../listing/context/OnPremOrderListingContext";

export const ClearSelectedOnPremOrdersButton: React.VFC = () => {
    const { selectedItems, setSelectedItems } = useContext(OnPremOrderListingContext);

    const clear = () => {
        setSelectedItems([]);
    };

    if (!selectedItems.length) return <></>;

    return (
        <CommandBarButton
            iconProps={{ iconName: "Cancel" }}
            onClick={clear}
            text={`${selectedItems.length} selected`}
        />
    );
};
